module.exports = __webpack_public_path__ + "static/img/tabela.8edc9f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tonica/tabela.png
// module id = Avcj
// module chunks = 0